import { useQuery } from '@tanstack/react-query';
import { StationsService } from '../service/stations';
const stationsService = new StationsService();

export function useStations() {
  const stationsQuery = useQuery({
    queryKey: ['stations'],
    queryFn: () => stationsService.getStations(),
    staleTime: 60_000,
    retry: 2,
  });

  /* const validStations = useMemo(() => {
    const data = stationsQuery.data ?? []; 
    return data
      .filter((s) => !isOlderThanMinutes(s.lastReading, MAINT_THRESHOLD_MIN)) 
  }, [stationsQuery.data]);

 useEffect(() => {
    if (!stationsQuery.isSuccess) return;
    const preferred = validStations.find((s) => s.station === PREFERRED_STATION_NAME);
    setSelectedStation(preferred ?? validStations[0] ?? null);
  }, [stationsQuery.isSuccess, validStations]);

  const weatherQuery = useQuery({
    queryKey: ['weather', selectedStation],  
    queryFn: () =>
      climaService.getWeatherForecast({
        lat: Number(selectedStation!.latitude),
        lon: Number(selectedStation!.longitude),
      }),
    enabled: !!selectedStation,  
    select: (resp) => (resp?.dados?.hoje ? filterWeatherEvery3Hours(resp.dados.hoje) : null),
    staleTime: 10 * 60_000,
    retry: 1,
  }); */

  return {
    stations: stationsQuery.data ?? [],
    stationsLoading: stationsQuery.isLoading,
    stationsError: stationsQuery.isError,
  };
}
